import { render } from "./ContentsAudiobooks.vue?vue&type=template&id=2860bd1e&scoped=true"
import script from "./ContentsAudiobooks.vue?vue&type=script&lang=js"
export * from "./ContentsAudiobooks.vue?vue&type=script&lang=js"

import "./ContentsAudiobooks.vue?vue&type=style&index=0&id=2860bd1e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2860bd1e"]])

export default __exports__